import React from 'react'
import Header from '../../subcategory/Header'
import SubCard from '../../../../../comon/SubCard'
import AnulomImg from '../../../../../assets/images/yoga/Anulom.png'
import PadangusthasanaImg from '../../../../../assets/images/yoga/Padangusthasana.png'
import { useTranslation } from 'react-i18next'

const Anxienty = () => {
    const {t} = useTranslation();
    return (
      <>
      <Header headtitle={t("yoga.anxietyyoga")} />
      <SubCard fitImg={AnulomImg} title={t("Anulom.title")} context={false} workoutLink='/anulom' />
      <SubCard fitImg={PadangusthasanaImg} title={t("Padangusthasana.title")} context={false} workoutLink='/padangusthasana' />
      </>
    )
  }

export default Anxienty
